import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Helpers
import { checkValidity } from '../../helpers/helpers.js'

const SessionForm = observer(class SessionForm extends React.Component {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const accessCode = this.key.value;

    this.key.value = '';

    // Add installSid to parent state so we can use it for other endpoints
    // this.props.parent.setState({
    //   installSid,
    //   examSid
    // });

    // Dialog message in case the session is already there
    const dialogContent = this.props.translation.already_exists;

    // this.props.store.ManagerStore.getExamSession(installSid, examSid, sessionSid, dialogContent, this.props.parent);

    this.props.store.ManagerStore.getSession(accessCode, this.props.parent, dialogContent);
    this.props.store.ManagerStore.addSession = false;
  }

  render() {
    const { translation } = this.props;

    return(
      // Will be used when access key endpoint is set up
      <form className="form-inline" onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
        <ul className="fields">
          <li>
            <label className="lbl-required" htmlFor="session-key">{translation.access_key}</label>
            <input
              type="text"
              id="session-key"
              ref={(input) => {this.key = input}}
              required
              aria-required="true"
              autoFocus
            />
          </li>
        </ul>

        <button className="btn btn--inline" type="submit">Open Session</button>
      </form>
    )
  }
})

export default translate('SessionForm')(SessionForm);


// WEBPACK FOOTER //
// ./src/app/components/Outside/SessionForm.js